import { FC } from "react";

import { Box } from "@chakra-ui/react";

import { Divider, FullWidthVStack } from "@components/common";
import responsiveStyle from "@lib/theme/responsiveStyle";

import { OrderStep } from "../../constants";
import useCommonOrderSideEffects from "../../hooks/common/useCommonOrderSideEffects";
import useReceiverSideEffects from "../../hooks/receiver/useReceiverSideEffects";
import OrderFooter from "../common/OrderFooter";
import OrderForm from "../common/OrderForm";
import OrderPrice from "../common/OrderPrice";
import ReceiverFormFields from "./ReceiverFormFields";

const Receiver: FC = () => {
  useCommonOrderSideEffects(OrderStep.ReceiverDetails);
  useReceiverSideEffects();

  return (
    <OrderForm style={{ height: "100%" }}>
      <FullWidthVStack spacing={responsiveStyle({ mobile: "1.625rem", desktop: "2.25rem" })} height="100%">
        <FullWidthVStack spacing={responsiveStyle({ mobile: "1.625rem", desktop: "2.25rem" })} flex="1">
          <Box width={responsiveStyle({ mobile: "100%", desktop: "50%" })}>
            <ReceiverFormFields />
          </Box>

          <Divider />
          <OrderPrice withPromo={false} />
        </FullWidthVStack>
        <OrderFooter currentStep={OrderStep.ReceiverDetails} />
      </FullWidthVStack>
    </OrderForm>
  );
};
export default Receiver;
